module.exports = __webpack_public_path__ + "img/16_Social Networker.142836e9.svg";